import { useMemo, useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { curName, curSymbol } from "@/lib/money";

export default function CurrencyPicker({ value, onChange, codes, testId, className = "" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    return codes.map((c) => [c, curName(c)]).filter(([c, n]) => !s || c.toLowerCase().includes(s) || n.toLowerCase().includes(s));
  }, [codes, q]);
  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (!o) setQ(""); }}>
      <PopoverTrigger asChild>
        <button type="button" className={`mm-input flex items-center justify-between gap-2 text-left ${className}`} data-testid={testId}>
          <span className="truncate"><b className="num">{value}</b> <span className="text-[var(--mu)]">{curSymbol(value)} · {curName(value)}</span></span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="mm-dialog w-72 p-2" align="start">
        <input autoFocus className="mm-input mb-2 !py-2 text-sm" placeholder="Search currency or country money…" value={q} onChange={(e) => setQ(e.target.value)} data-testid={`${testId}-search`} />
        <div className="max-h-64 overflow-y-auto">
          {list.map(([c, n]) => (
            <button type="button" key={c} onClick={() => { onChange(c); setOpen(false); setQ(""); }} className="flex w-full items-center gap-2 rounded-lg px-2 py-1.5 text-left text-sm hover:bg-[var(--bg)]" data-testid={`${testId}-option-${c}`}>
              <b className="num w-11">{c}</b><span className="flex-1 truncate">{n}</span><span className="text-[var(--mu)]">{curSymbol(c)}</span>
              {c === value && <Check className="h-4 w-4 text-[var(--ac)]" />}
            </button>
          ))}
          {!list.length && <p className="p-2 text-sm text-[var(--mu)]">No match.</p>}
        </div>
      </PopoverContent>
    </Popover>
  );
}
